var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "person-auth-root" }, [
    _c(
      "div",
      { staticClass: "box" },
      [
        _c("div", { staticClass: "step-box" }, [
          _c("div", { staticClass: "font-family font-26 step1" }, [
            _vm._v("\n          01基本信息\n        ")
          ]),
          _c(
            "div",
            {
              staticClass: "font-family font-26",
              class: {
                "un-start": _vm.authStep == 1,
                doing: _vm.authStep > 1
              }
            },
            [_vm._v("\n          02提交结果\n        ")]
          ),
          _c("div")
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.authStep == 1,
                expression: "authStep == 1"
              }
            ]
          },
          [
            _vm.isContinent
              ? _c("mainland", {
                  ref: "inland",
                  attrs: {
                    backUrl: _vm.backUrl,
                    authStep: _vm.authStep,
                    isContinent: _vm.isContinent,
                    APIAUTHINFO: _vm.APIAUTHINFO
                  },
                  on: {
                    "update:backUrl": function($event) {
                      _vm.backUrl = $event
                    },
                    "update:back-url": function($event) {
                      _vm.backUrl = $event
                    },
                    "update:isContinent": function($event) {
                      _vm.isContinent = $event
                    },
                    "update:is-continent": function($event) {
                      _vm.isContinent = $event
                    },
                    loadingStart: _vm.loadingStart,
                    loadingClose: _vm.loadingClose
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.authStep === 2,
                expression: "authStep === 2"
              }
            ]
          },
          [_vm._m(0)]
        ),
        _c(
          "div",
          { staticClass: "step-btn" },
          [
            _c(
              "el-checkbox",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.authStep == 1,
                    expression: "authStep == 1"
                  }
                ],
                model: {
                  value: _vm.agreement,
                  callback: function($$v) {
                    _vm.agreement = $$v
                  },
                  expression: "agreement"
                }
              },
              [
                _c("span", { staticStyle: { color: "#666666" } }, [
                  _vm._v("我已阅读并同意")
                ]),
                _c(
                  "a",
                  {
                    staticClass: "showAgreement",
                    staticStyle: { color: "#409EFF" },
                    attrs: { href: "javascript:void(0)" },
                    on: {
                      click: function($event) {
                        _vm.showProtocol = true
                      }
                    }
                  },
                  [_vm._v("《实名认证服务协议》")]
                ),
                _c(
                  "a",
                  {
                    staticClass: "showAgreement",
                    staticStyle: { color: "#409eff" },
                    attrs: { href: "javascript:void(0)" },
                    on: {
                      click: function($event) {
                        _vm.showPrivacyProtocol = true
                      }
                    }
                  },
                  [_vm._v("《用户隐私政策协议》")]
                ),
                _c(
                  "a",
                  {
                    staticClass: "showAgreement",
                    staticStyle: { color: "#409eff" },
                    attrs: { href: "javascript:void(0)" },
                    on: {
                      click: function($event) {
                        _vm.showNumberProtocol = true
                      }
                    }
                  },
                  [_vm._v("《数字证书服务协议》")]
                )
              ]
            ),
            _c(
              "div",
              { staticStyle: { "margin-top": "20px" } },
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.authStep == 1,
                        expression: "authStep == 1"
                      }
                    ],
                    attrs: { type: "danger" },
                    on: { click: _vm.nextStep }
                  },
                  [_vm._v("提交认证")]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.authStep == 2 && _vm.APIAUTHINFO.backUrl,
                        expression: "authStep == 2 && APIAUTHINFO.backUrl"
                      }
                    ],
                    attrs: { type: "danger" },
                    on: { click: _vm.authSuc }
                  },
                  [_vm._v("完成（" + _vm._s(_vm.countdownTime) + "s）")]
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "提示",
              visible: _vm.APIAUTHINFO.code === "10214",
              "show-close": false,
              width: "30%"
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.APIAUTHINFO, "code === '10214'", $event)
              }
            }
          },
          [
            _c("span", [_vm._v("链接失效，请重新获取认证链接")]),
            _c("span", {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            })
          ]
        ),
        _c("real-name-protocol", {
          attrs: { visible: _vm.showProtocol, type: "register" },
          on: {
            "update:visible": function($event) {
              _vm.showProtocol = $event
            }
          }
        }),
        _c("privacy-protocol", {
          attrs: { visible: _vm.showPrivacyProtocol, type: "register" },
          on: {
            "update:visible": function($event) {
              _vm.showPrivacyProtocol = $event
            }
          }
        }),
        _c("number-protocol", {
          attrs: { visible: _vm.showNumberProtocol, type: "register" },
          on: {
            "update:visible": function($event) {
              _vm.showNumberProtocol = $event
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { margin: "100px 0", "text-align": "center" } },
      [
        _c("img", { attrs: { src: "/images/auth/authIcon/suc.png", alt: "" } }),
        _c(
          "p",
          {
            staticStyle: {
              margin: "20px 0",
              "font-weight": "bold",
              "font-size": "16px"
            }
          },
          [_vm._v("提交成功")]
        )
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2fc73986", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fc73986","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/auth/APIAuth/justRegister/index.vue
// module id = TzpG
// module chunks = 88